// @flow
import styled from "styled-components"
import { Text } from "componentsStyled/Typography/Texts"

export const ClearButton = styled(Text)`
  margin-left: 1rem;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/pages/_Page/MainFilter/DesktopFilters/styled.js